import { render } from "./sellInvoiceList.vue?vue&type=template&id=8c86171a&scoped=true"
import script from "./sellInvoiceList.vue?vue&type=script&lang=js"
export * from "./sellInvoiceList.vue?vue&type=script&lang=js"

import exportComponent from "C:\\projects\\carenvisitorapp\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c86171a"]])

export default __exports__